import { put, takeEvery } from "redux-saga/effects";
import {
  FETCH_CUSTOMER_WISHLIST_ITEMS,
  FETCH_WISHLIST_CATEGORY_LIST,
  FETCH_WISHLIST_DATA,
  GENERATE_WISHLIST_ITEM_REPORT,
  GENERATE_WISHLIST_STORE_REPORT,
  SEND_WISHLIST_REMINDER,
  SET_WISHLIST_FLAG,
} from "./../ActionTypes/wishlist";
import { ToastNotifyError } from "./../../Components/Toast";
import config from "./../../Config";
import apiCall from "./../../Services/api";
import { WISHLIST_ROUTE } from "../../Services/apiUrls";
import { openWhatsAppWeb, parseToJson } from "../../Utils/common";
import { setPageLoaderVisibility } from "../Actions";
import { saveWishlistData, WishlistAction } from "../Actions/wishlist";
import { COMMUNICATION_MODE } from "@/Containers/CustomerRelationManagement/constants/index";

function* fetchWishlistData(actions: WishlistAction) {
  try {
    yield put(setPageLoaderVisibility(true));
    const wishlistResponse = yield apiCall({
      method: "GET",
      url: `${config.base_url}${WISHLIST_ROUTE.fetchWishlistItemsByFilters(actions?.data)}`,
      parseToJson: true,
    });
    if (wishlistResponse?.data?.status) {
      yield put(saveWishlistData(wishlistResponse?.data?.data));
      yield put(setPageLoaderVisibility(false));
    }
  } catch (err) {
    yield put(setPageLoaderVisibility(false));
    ToastNotifyError("Unable to fetch wishlist data");
  } finally {
    yield put(setPageLoaderVisibility(false));
  }
}

function* fetchWishlistCategoryList(actions: WishlistAction) {
  try {
    yield put(setPageLoaderVisibility(true));
    const wishlistCategoryListResponse = yield apiCall({
      method: "GET",
      url: `${config.base_url}${WISHLIST_ROUTE.fetchWishlistCategoryList}`,
      parseToJson: true,
    });
    if (wishlistCategoryListResponse?.data?.status) {
      //   yield put(saveWishlistCategoryList(wishlistCategoryListResponse?.data?.data));
      actions?.callback(wishlistCategoryListResponse?.data);
      yield put(setPageLoaderVisibility(false));
    }
  } catch (err) {
    yield put(setPageLoaderVisibility(false));
    ToastNotifyError("Unable to fetch wishlist category list");
  } finally {
    yield put(setPageLoaderVisibility(false));
  }
}

function* fetchCustomerWishlistItems(actions: WishlistAction) {
  try {
    yield put(setPageLoaderVisibility(true));
    const customerWishlistItemResponse = yield apiCall({
      method: "GET",
      url: `${config.base_url}${WISHLIST_ROUTE.fetchCustomerWishlistItems(actions?.data?.phone, actions.data?.user_id)}`,
      parseToJson: true,
    });
    if (customerWishlistItemResponse?.data?.status) {
      actions.callback(customerWishlistItemResponse?.data?.data);
      yield put(setPageLoaderVisibility(false));
    }
  } catch (err) {
    yield put(setPageLoaderVisibility(false));
    ToastNotifyError("Unable to fetch customer wishlist data");
  } finally {
    yield put(setPageLoaderVisibility(false));
  }
}

function* generateWishlistItemReport(actions: WishlistAction) {
  try {
    yield put(setPageLoaderVisibility(true));
    const itemWishlistReportResponse = yield apiCall({
      method: "GET",
      url: `${config.base_url}${WISHLIST_ROUTE.generateWishlistItemReport(actions.data?.item_id)}`,
      parseToJson: true,
    });
    if (itemWishlistReportResponse?.data?.status) {
      actions?.callback(itemWishlistReportResponse?.data?.data);
      yield put(setPageLoaderVisibility(false));
    }
  } catch (err) {
    yield put(setPageLoaderVisibility(false));
    ToastNotifyError("Report download failed");
  } finally {
    yield put(setPageLoaderVisibility(false));
  }
}

function* generateWishlistStoreReport(actions: WishlistAction) {
  try {
    yield put(setPageLoaderVisibility(true));
    const storeWishlistReportResponse = yield apiCall({
      method: "POST",
      url: `${config.base_url}${WISHLIST_ROUTE.generateWishlistStoreReport}`,
      data: actions.data,
    });
    if (storeWishlistReportResponse?.data?.status) {
      actions?.callback(true);
      yield put(setPageLoaderVisibility(false));
    }
  } catch (err) {
    yield put(setPageLoaderVisibility(false));
    ToastNotifyError("Report download failed");
  } finally {
    yield put(setPageLoaderVisibility(false));
  }
}

function* setWishlistFlag(actions: WishlistAction) {
  try {
    yield put(setPageLoaderVisibility(true));
    const storeWishlistReportResponse = yield apiCall({
      method: "PUT",
      url: `${config.base_url}${WISHLIST_ROUTE.setWishlistPage}`,
      data: actions.data,
    });
    if (storeWishlistReportResponse?.data?.status) {
      actions?.callback(true);
      yield put(setPageLoaderVisibility(false));
    }
  } catch (err) {
    yield put(setPageLoaderVisibility(false));
  } finally {
    yield put(setPageLoaderVisibility(false));
  }
}

function* sendWishlistReminder(actions: WishlistAction) {
  try {
    yield put(setPageLoaderVisibility(true));
    const response = yield apiCall({
      method: "PATCH",
      url: `${config.base_url}${WISHLIST_ROUTE.sendWishlistReminder}`,
      data: actions.data,
    });
    if (response?.data?.status) {
      actions?.callback(response?.data?.status);
      if (actions.data?.communication_mode === COMMUNICATION_MODE.WHATSAPP) {
        openWhatsAppWeb({
          phone: actions?.data?.user_phone,
          whatsapp_text: parseToJson(response.data.data),
        });
      }
      yield put(setPageLoaderVisibility(false));
    }
  } catch (err) {
    yield put(setPageLoaderVisibility(false));
  } finally {
    yield put(setPageLoaderVisibility(false));
  }
}

export default function* root() {
  yield takeEvery(FETCH_WISHLIST_DATA, fetchWishlistData);
  yield takeEvery(FETCH_WISHLIST_CATEGORY_LIST, fetchWishlistCategoryList);
  yield takeEvery(FETCH_CUSTOMER_WISHLIST_ITEMS, fetchCustomerWishlistItems);
  yield takeEvery(GENERATE_WISHLIST_ITEM_REPORT, generateWishlistItemReport);
  yield takeEvery(GENERATE_WISHLIST_STORE_REPORT, generateWishlistStoreReport);
  yield takeEvery(SET_WISHLIST_FLAG, setWishlistFlag);
  yield takeEvery(SEND_WISHLIST_REMINDER, sendWishlistReminder);
}
